import { keccak256, encodePacked, type Hex } from 'viem';

/**
 * Derive cohort ID from title
 */
export function deriveCohortId(title: string): Hex {
  return keccak256(encodePacked(['string'], [title]));
}

/**
 * Derive participant ID from name
 */
export function deriveParticipantId(name: string): Hex {
  return keccak256(encodePacked(['string'], [name]));
}

/**
 * Derive multiple participant IDs
 */
export function deriveParticipantIds(names: string[]): Map<string, Hex> {
  const map = new Map<string, Hex>();
  for (const name of names) {
    map.set(name, deriveParticipantId(name));
  }
  return map;
}
